import {Controller, useFormContext} from "react-hook-form";
import {ContactTypeMap, NoContactInput} from "../../domain";
import {DropdownMultiSelect} from "common";
import React from "react";
import {SPLIT_DELIMITER, splitAndRemoveEmpty} from "../../../../placement/const";

type InitialTypeOfContactInputProps = {
    sending: boolean;
};

export function InitialTypeOfContactInput({sending}: InitialTypeOfContactInputProps) {
    const {
        setValue,
        clearErrors,
        control,
        watch,
        formState: {
            errors
        },
    } = useFormContext<NoContactInput>();

    return (
        <div className="w-full text-black-200 pb-2 text-base items-center">
            <div className="flex items-center">
                <div className="w-2/6 text-right">
                    Initial Type of Contact
                </div>
                <div className="w-1/6 ml-4 items-center">
                    <Controller
                        name="initialTypeOfContact"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={() =>
                            <DropdownMultiSelect
                                field={'initialTypeOfContact'}
                                options={Array.from(ContactTypeMap.keys())}
                                labelMapperFunc={(val) => ContactTypeMap.get(val)!!}
                                disabled={sending}
                                value={watch("initialTypeOfContact")}
                                setValue={(value: string) => {
                                    setValue("initialTypeOfContact", splitAndRemoveEmpty(value).join(SPLIT_DELIMITER))
                                    clearErrors("initialTypeOfContact");
                                }}
                            />
                        }/>
                </div>
            </div>

            {
                errors.initialTypeOfContact &&
                <div className="pt-2 flex w-full">
                    <div className="w-2/6">
                    </div>
                    <div className="w-4/6 ml-6 text-red-700">
                        Please select “Initial Type of Contact” before submitting
                    </div>
                </div>
            }
        </div>
    );
}
